import React, { useEffect } from 'react'
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import '../../../assets/styles/StylePopup.css'
import { VariableWarehouse } from './VariableWarehouse';
import { Form } from '../../../components/general/general-component/abstruct-component/AbstructForm';
import { AbstructVar } from '../../../components/general/general-component/abstruct-component/AbstructVar';
import { AbstructLang } from '../../../components/general/general-component/abstruct-component/AbstructLang';
import { postWarehouse } from '../../../store/Actions/ActionWarehouses';

function AddWarehouse({ open, setOpen }) {

  const { mode, dispatch, navigate, langLocal } = AbstructVar();

  const { translate } = AbstructLang();

  const { state, setStateCustom, setLoad } = VariableWarehouse();

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(postWarehouse(state, setLoad));
  };

  const formFields = [
    { name: 'name', label: 'name', type: 'text', inputType: 'text', iconType: "pencil" },
    { name: 'city', label: 'city', type: 'text', inputType: 'text', iconType: "city" },
    { name: 'country', label: 'country', type: 'text', inputType: 'text', iconType: "city" },
    { name: 'location', label: 'location', type: 'text', inputType: 'text', iconType: "location" },
    { name: 'phone_number', label: 'phone', type: 'number', inputType: 'text', iconType: "phone" },
    { name: 'notes', label: 'notes', type: 'text', inputType: 'text', iconType: "pencil" },
    {
      name: 'status',
      label: 'Status',
      type: 'text',
      inputType: 'one_select',
      iconType: "check",
      options: [{value: 1,label: 'active'},{value: 0,label: 'un active'}]
    },
  ];

  return (
    <RModal
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      center
      classNames={{
        modal: 'popupR',
      }}
      focusTrapped={false}
      overlayOpacity={0.5}
    >
      <div className={`div_popup ${mode === 'dark' ? 'darkPopUp' : 'lightPopUp'}`}>
        <div className={`div_title_popup ${mode === 'dark' ? 'darktoppopup' : 'lighttoppopup'}`}>
          <p className={`title_popup ${mode === 'dark' ? 'darktext' : 'lighttext'}`}>{translate('add-warehouse')}</p>
        </div>
        <Form langLocal={langLocal} fields={formFields} handleSubmit={handleSubmit} state={state} setStateCustom={setStateCustom} buttonLabel="add" />
      </div>
    </RModal>
  );
}

export default AddWarehouse;